(function () {
	'use strict';

	const onLoadComplete = callback => {
		if (callback && typeof callback === 'function') {
			if (document.readyState === 'complete') {
				callback();
			} else {
				window.addEventListener('load', () => {
					callback();
				});
			}
		} else {
			console.error('onLoadComplete requires a callback function');
		}
	};

	window.FS = window.FS || {};
	window.FS.GDPR = window.FS.GDPR || {};

	const isWls = window.isWls;

	const togglePreferences = e => {
		e.preventDefault();
		if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
			window.OneTrust.ToggleInfoDisplay();
		}
	};

	//Add Footer button before adding the script
	//check if we're on a 3.0 page, rbf has it added directly
	var legalList = document.querySelector('ul.PageFooter-legal');

	if (!!legalList) {
		const translations = JSON.parse(legalList.dataset.cookieTranslations);
		let footerLiClasses = ['PageFooter-legalItem', 'ty-c4'];
		let footerButtonClasses = 'CTA CTA--underlined--light PageFooter-legalLink ty-c4';

		//try to fetch the classes from the other buttons before setting any
		const firstLi = legalList.querySelector('li');
		if (!!firstLi) {
			footerLiClasses = Array.from(firstLi.classList);
			const firstLiChildEl = firstLi.firstElementChild;
			if (!!firstLiChildEl) {
				footerButtonClasses = firstLiChildEl.classList.value;
			}
		}
		const cookiePreferencesItem = document.createElement('li');
		cookiePreferencesItem.classList.add(...footerLiClasses);

		if (!isWls) {
			cookiePreferencesItem.innerHTML = `<button id="ot-sdk-btn" class="ot-sdk-show-settings fs-footer-button">${translations.cookieSettings}</button>`;
		} else {
			cookiePreferencesItem.innerHTML = `<button class="${footerButtonClasses} ">${translations.cookiePreferences}</button>`;
			cookiePreferencesItem.onclick = togglePreferences;
		}

		const dontSellItem = document.createElement('li');
		dontSellItem.classList.add(...footerLiClasses);
		dontSellItem.innerHTML = `<button class="${footerButtonClasses} ">${translations.dontSell}</button>`;
		dontSellItem.onclick = togglePreferences;

		var legalLinks = legalList.querySelectorAll('li.PageFooter-legalItem');
		if (legalLinks.length > 2) {
			legalList.insertBefore(cookiePreferencesItem, legalLinks[2]);
			legalList.insertBefore(dontSellItem, legalLinks[2]);
		} else {
			legalList.appendChild(cookiePreferencesItem);
			legalList.appendChild(dontSellItem);
		}
	} else {
		// look for links that should open the preferences panel
		const cookiePreferenceLinks = document.querySelectorAll('.fs-open-cookie-preferences');

		if (cookiePreferenceLinks) {
			for (const link of cookiePreferenceLinks) {
				link.onclick = togglePreferences;
			}
		}
	}

	//Called whenever consent is changed
	var onChangeCbs = [];
	window.FS.GDPR.onConsentChange = function (cb) {
		onChangeCbs.push(cb);
	};

	//Called when active groups is loaded
	var getSavedCbs = [];
	window.FS.GDPR.getSavedConsent = function (cb) {
		if (window['OnetrustActiveGroups']) {
			cb(getCookieCategories(window['OnetrustActiveGroups'].split(',')));
		} else {
			getSavedCbs.push(cb);
		}
	};

	//Call the cb immediately if groups are already loaded and the specified category is active
	//Otherwise queue it and check when OneTrust has loaded
	var activeCategoryCbs = {};
	window.FS.GDPR.ifAllowed = function (category, cb) {
		if (window['OnetrustActiveGroups']) {
			var cookieCategories = getCookieCategories(window['OnetrustActiveGroups']);
			if (cookieCategories[category]) {
				cb();
			}
		} else {
			if (activeCategoryCbs[category]) {
				activeCategoryCbs[category].push(cb);
			} else {
				activeCategoryCbs[category] = [cb];
			}
		}
	};

	// this just serves as a cache record of which scripts have been loaded so we don't end up trying to load the same script multiple times.
	const loadedScripts = {};

	/**
	 *
	 * @param {*} scriptOptions: script: path to script, async: whether to load asn
	 * @param {*} requiredCategory: which category need to be checked
	 * @param {*} ifAllowed: cb function called if the script is added to the page. This does not necessarily mean the script has LOADED though. Implementing code will need to handle whether the script has loaded or not.
	 * @param {*} ifNot : cb function called if the script is not added to the page
	 */
	window.FS.GDPR.loadScript = function (
		{ script, tagOptions = {} },
		requiredCategory,
		ifAllowed = () => {},
		ifNot = () => {}
	) {
		window.FS.GDPR.getSavedConsent(consentStatus => {
			if (consentStatus[requiredCategory]) {
				if (!loadedScripts[script]) {
					var tag = document.createElement('script');
					tag.src = script;

					Object.keys(tagOptions).forEach(option => {
						tag[option] = tagOptions[option];
					});

					var firstScriptTag = document.getElementsByTagName('script')[0];
					firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

					//record that we've loaded this script
					loadedScripts[script] = true;
				}

				ifAllowed();
			} else {
				ifNot();
			}
		});
	};

	if (window.FS?.globalInfo?.oneTrustTag) {
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.charset = 'UTF-8';
		script.dataset.documentLanguage = true;
		script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
		script.dataset.domainScript = window.FS.globalInfo.oneTrustTag;

		var wrapper = document.createElement('script');
		wrapper.type = 'text/javascript';
		wrapper.innerHTML = 'function OptanonWrapper() { }';

		document.head.insertBefore(wrapper, document.head.firstChild);
		document.head.insertBefore(script, document.head.firstChild);

		//Remove the old banner
		var bannerCss =
			document.querySelector('div[fs-gdpr-banner]') ||
			document.querySelector('link[href*="/alt/fshr/shared/css/gdpr-banner"');
		var bannerHtml = document.getElementById('GdprCookieBanner');
		if (bannerCss) bannerCss.remove();
		if (bannerHtml) bannerHtml.remove();
	}

	var getCookieCategories = function (groups) {
		groups = groups || [];
		return {
			necessary: groups.includes('C0001'),
			performance: groups.includes('C0002'),
			functional: groups.includes('C0003'),
			ads: groups.includes('C0004'),
			social: groups.includes('C0005'),
		};
	};

	// function to pull cookie value
	function getOABCookie(name) {
		var value = '; ' + document.cookie;
		var parts = value.split('; ' + name + '=');
		if (parts.length == 2) return parts.pop().split(';').shift();
	}

	var setPageRefreshHandlers = function () {
		// console.log('OptanonWrapper called');
		var OABCcookieName = 'OptanonAlertBoxClosed';
		var bannerAcceptBtn = document.getElementById('onetrust-accept-btn-handler');
		var pcAllowAllBtn = document.getElementById('accept-recommended-btn-handler');
		var pcSaveBtn = document.getElementsByClassName(
			'save-preference-btn-handler onetrust-close-btn-handler'
		)[0];
		var OABCcookie = getOABCookie(OABCcookieName);

		// IF logic needed here because ot-banner-sdk DIV is not injected on page loads if banner is not exposed
		if (!OABCcookie && bannerAcceptBtn) {
			bannerAcceptBtn.addEventListener('click', function () {
				// console.log('Allowed all via Banner');
				location.reload();
			});
		}
		if (pcAllowAllBtn)
			pcAllowAllBtn.addEventListener('click', function () {
				// console.log('Allowed all via Preference Center');
				location.reload();
			});
		if (pcSaveBtn) {
			pcSaveBtn.addEventListener('click', function () {
				setTimeout(() => {
					// console.log('Set custom settings via Preference Center');
					location.reload();
				}, 1000); //quick timeout so that the consent receipt can be sent and the cookie can be updated
			});
		}
	};

	//poll every half second for 30 seconds
	var maxWaitTime = 30000;
	var waitFor = function (valueName, cb, timeoutCb, timeStarted) {
		timeStarted = timeStarted || new Date().getTime();
		if (window[valueName]) {
			cb();
		} else if (new Date().getTime() - timeStarted >= maxWaitTime) {
			timeoutCb();
		} else {
			setTimeout(function () {
				waitFor(valueName, cb, timeoutCb, timeStarted);
			}, 500);
		}
	};
	const init = function () {
		//On Consent Changed
		waitFor(
			'OneTrust',
			function () {
				setPageRefreshHandlers();
				//Found Handler
				window.OneTrust.OnConsentChanged(function (e) {
					onChangeCbs.forEach(function (cb) {
						cb(getCookieCategories(e.detail));
					});
				});
			},
			function () {
				//Timeout Handler
				console.error('Failed to find OneTrust after 30 seconds.');
			}
		);

		//Return which groups are active
		waitFor(
			'OnetrustActiveGroups',
			function () {
				//Found Handler
				var cookieCategories = getCookieCategories(window.OnetrustActiveGroups.split(','));
				getSavedCbs.forEach(function (cb) {
					cb(cookieCategories);
				});

				Object.keys(cookieCategories)
					.filter(function (category) {
						return cookieCategories[category] && activeCategoryCbs[category];
					})
					.forEach(function (category) {
						while (activeCategoryCbs[category].length > 0) {
							activeCategoryCbs[category].pop()();
						}
					});
			},
			function () {
				//Timeout Handler
				console.error('Failed to find OneTrust Active Groups after 30 seconds.');
				getSavedCbs.forEach(function (cb) {
					cb(getCookieCategories([]));
				});
			}
		);
	};
	onLoadComplete(init);
})();
